/**
 * JURO — play videos only while on screen
 * ------------------------------------------------------------------
 * Any <video data-juro-autoplay> plays muted and looped while visible and
 * pauses when scrolled past, so a clip below the fold is not decoding frames
 * and draining battery for nothing.
 *
 * Uses the shared helper in juro-scroll rather than another observer per
 * video.
 */

import { playWhileVisible } from '@theme/juro-scroll';

function init() {
  for (const video of document.querySelectorAll('video[data-juro-autoplay]')) {
    if (video.dataset.juroWired) continue;
    video.dataset.juroWired = 'true';
    playWhileVisible(video);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
